<template>
    <div :style="{ background: colors.messageList.bg }" class="sc-suggestions-row">
        <button
            v-for="(suggestion, idx) in suggestions"
            :key="idx"
            :style="{
                borderColor: colors.sentMessage.bg,
                color: colors.sentMessage.bg,
            }"
            class="sc-suggestions-element"
            v-on:click="$emit('sendSuggestion', suggestion)"
        >
            {{ suggestion }}
        </button>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    props: {
        suggestions: {
            type: Array,
            default: () => [],
        },
        colors: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style>
.sc-suggestions-row {
    text-align: center;
    background: inherit;
}

.sc-suggestions-element {
    margin: 3px;
    padding: 5px 10px 5px 10px;
    border: 1px solid;
    border-radius: 15px;
    font-size: 14px;
    background: inherit;
    cursor: pointer;
}
</style>
